export const crossSVG =
	'<svg id="crossSVG" width="100%" height="100%"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 13"><path d="M1.5 1.5l10.05 10.05M11.5 1.5L1.45 11.55" stroke-width="2" fill="none" fill-rule="evenodd" stroke-linecap="round"></path></svg>';
